/**
 * Public API values for MK2 Redis `state.app` breadcrumb paths.
 * Mirrors main-server MeterAppState.
 */
export enum MeterAppState {
  RunAlgorithm = 'RunAlgorithm',
  PreCommissioned = 'PreCommissioned',
  Service = 'Service',
  ShutdownPermanent = 'ShutdownPermanent',
  ShutdownIdle = 'ShutdownIdle',
  ShutdownReset = 'ShutdownReset',
  Unknown = 'Unknown',
}

/** Human-readable meaning for each {@link MeterAppState}. */
export const METER_APP_STATE_DESCRIPTIONS: Record<MeterAppState, string> = {
  [MeterAppState.RunAlgorithm]: 'Normal operation state',
  [MeterAppState.PreCommissioned]: 'Pre-commissioning, waiting for configuration',
  [MeterAppState.Service]: 'Service or engineering mode',
  [MeterAppState.ShutdownPermanent]: 'Shutdown, stay down',
  [MeterAppState.ShutdownIdle]: 'Shutdown, will recover on reset',
  [MeterAppState.ShutdownReset]: 'About to reboot',
  [MeterAppState.Unknown]: 'Unknown state',
};
